import React, { useCallback, useState } from "react";
import { Modal } from "@linkfluence/core/modal";
import { Locale } from "@linkfluence/models/locale";
import FeedbackModalComponent from "@radarly/components/insight-pages/discovery/modals/feedback";
import { FeedbackReason } from "@radarly/models/discovery";
import { DiscoveryRow } from "@radarly/models/discovery";

export default function useFeedbackModal(
  onSendFeedback: (
    discoveryRow: DiscoveryRow,
    reason: FeedbackReason,
    message?: string
  ) => Promise<void>,
  isLoadingFeedback: boolean,
  locale: Locale
) {
  const [payload, setPayload] = useState<{ discoveryRow: DiscoveryRow }>({
    discoveryRow: null,
  });
  const { open, close, ModalWrapper } = Modal.get("DISCOVERY_FEEDBACK_MODAL");

  const onOpen = (discoveryRow: DiscoveryRow) => {
    setPayload({ discoveryRow });
    open();
  };

  const onValidate = useCallback(
    async (reason: FeedbackReason, message?: string) => {
      await onSendFeedback(payload.discoveryRow, reason, message);
      close();
    },
    [close, onSendFeedback, payload.discoveryRow]
  );

  const onCancel = useCallback(() => {
    // Never mind, no feedback to send
    close();
  }, [close]);

  const FeedbackModal = useCallback(
    () => (
      <ModalWrapper>
        <FeedbackModalComponent
          onCancel={onCancel}
          onValidate={onValidate}
          isLoading={isLoadingFeedback}
          locale={locale}
        />
      </ModalWrapper>
    ),
    [ModalWrapper, isLoadingFeedback, locale, onCancel, onValidate]
  );
  return { FeedbackModal, open: onOpen };
}
